import React, {useContext, useEffect, useState} from "react";
import {Button, DatePicker, Form, Modal, Select} from "antd";
import {assetSearch, categoryList} from "../../../asset-category/action/asset-category.action";
import Locale from "../../../../../core/locale/locale";
import server from "../../../../../server";
import {PlusOutlined} from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import {assetAllocationModalProps, employee} from "../type/asset-allocation.types";
import dayjs, {Dayjs} from "dayjs";
import {X} from "lucide-react";
import AssetSelect from "../../../../common/asset-select/asset-select";
import UserLoginContext from "../../../../../context/userLoginContext";

const initialAssetState = {
    categoryId: '',
    assetId: '',
    assetList: [],
    disableAsset: true
};

const AssetAllocationModal = (props: assetAllocationModalProps) => {
    const [assetCategoryData, setAssetCategoryData] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [formState, setFormState] = useState({assets: [initialAssetState]});
    const {user} = useContext(UserLoginContext);

    const getInitialAssetState = () => ({
        categoryId: '',
        assetId: '',
        assetList: [],
        disableAsset: true
    });

    const handleAddAsset = () => {
        setFormState(prev => ({
            ...prev,
            assets: [...prev.assets, getInitialAssetState()]
        }));
    };

    const handleRemoveAsset = (index: number) => {
        const updated = formState.assets.filter((_, i) => i !== index);
        setFormState(prev => ({
            ...prev,
            assets: updated
        }));
    };

    useEffect(() => {
        fetchAssetCategory();
        getAllEmployees();
    }, [])

    useEffect(() => {
        // When modal closes: Reset to single empty row
        if (!props.assignAssetModal) {
            setFormState({assets: [getInitialAssetState()]});
            props.assignAssetForm.resetFields();
        }
    }, [props.assignAssetModal]);

    async function fetchAssetCategory() {
        try {
            const assetCategoryResponse = await categoryList();
            setAssetCategoryData(assetCategoryResponse)
        } catch (error) {
            console.log("Getting error while fetching asset categories", error)
        }
    }

    // fetchAssets function triggered when category changes
    const fetchAssets = async (categoryId: string, index: number) => {
        const payload = {
            status: "IN_STOCK",
            categoryId
        };
        try {
            const response = await assetSearch(undefined, undefined, payload);
            setFormState(prev => {
                const updated = [...prev.assets];
                updated[index].categoryId = categoryId;
                updated[index].assetList = response;
                updated[index].disableAsset = false;
                return {...prev, assets: updated};
            });
        } catch (e) {
            console.log(e);
        }
    };

    async function getAllEmployees() {
        if (user?.isAdmin) {
            try {
                const allEmployees = await server.employee.getAllEmployee();
                setEmployeeData(allEmployees);
            } catch (e) {
                console.log("Error while fetching employees", e)
            }
        }
    }

    const disableDate = (currentDate: Dayjs) => (
        //disable past date
        currentDate.valueOf() <= dayjs().startOf('day').valueOf()
    );

    return (
        <Modal
            className={"hrms-app assign-asset-modal"}
            title={"Allocate Asset"}
            open={props.assignAssetModal}
            onCancel={props.handleAssignAssetModalClose}
            onOk={async () => {
                try {
                    const values = await props.assignAssetForm.validateFields();
                    await props.handleAssetAssignSubmit(values);
                } catch (e) {
                    console.log(e)
                }
            }}
        >
            <Form form={props.assignAssetForm} layout={"vertical"}>
                <Form.Item label={"Select Employee"} name={'employeeId'}
                           rules={[{required: true, message: 'Select Employee'}]}>
                    <Select placeholder={"Select Employee"}>
                        {
                            employeeData.map((data: employee) => (
                                <Select.Option key={data.id} value={data.id}>
                                    {data.name.firstName} {data.name.lastName}
                                </Select.Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                <div className="asset-list-container">
                    <div className={'asset-list-container__header'}>
                        <h4 className={'title'}>Asset Selection</h4>
                        {/*<div className={'more-asset-div'}>*/}
                        <Button type="primary" onClick={handleAddAsset} className={'add-more-asset-button'}>
                            <PlusOutlined/> Add More Assets
                        </Button>
                        {/*</div>*/}

                    </div>

                    {formState.assets.map((item, index) => (
                        <div key={index} className="asset-row">
                            <h5 className={'asset-row-number'}>
                                Asset {index + 1}
                            </h5>
                            {formState.assets.length > 1 && (
                                <span className={'delete-btn'} onClick={() => handleRemoveAsset(index)}>
                                  <X/>
                                </span>
                            )}

                            <div className={'category-asset-wrapper'}>
                                <Form.Item
                                    label="Select Category"
                                    name={['assets', index, 'categoryId']}
                                    rules={[{required: true, message: 'Select Category'}]}
                                >
                                    <Select
                                        placeholder="Select Category"
                                        onChange={(value) => fetchAssets(value, index)}
                                    >
                                        {assetCategoryData.map((cat: any) => (
                                            <Select.Option key={cat.id} value={cat.id}>
                                                {cat.name}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    label="Select Asset"
                                    name={['assets', index, 'assetId']}
                                    rules={[{required: true, message: 'Select Asset'}]}
                                >
                                    <AssetSelect
                                        disabled={item.disableAsset}
                                        includeAllSelectOption={false}
                                        placeholder={'Select Asset'}
                                        categoryId={item.categoryId}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    ))}
                </div>
                <Form.Item label={"Expected Return Date"} name={'expectedReturnDate'}>
                    <DatePicker format={Locale.displayDate} disabledDate={disableDate}/>
                </Form.Item>
                <Form.Item label={"Remarks"} name={'adminRemarks'}>
                    <TextArea placeholder={"Enter Remarks"}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default AssetAllocationModal;





